import { render, staticRenderFns } from "./PremiumConceptDesc.vue?vue&type=template&id=3f87c1fe&scoped=true"
import script from "./PremiumConceptDesc.vue?vue&type=script&lang=js"
export * from "./PremiumConceptDesc.vue?vue&type=script&lang=js"
import style0 from "./PremiumConceptDesc.vue?vue&type=style&index=0&id=3f87c1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87c1fe",
  null
  
)

export default component.exports